import { render, staticRenderFns } from "./KegelFooter.vue?vue&type=template&id=3a4e1efb&"
import script from "./KegelFooter.vue?vue&type=script&lang=js&"
export * from "./KegelFooter.vue?vue&type=script&lang=js&"
import style0 from "./KegelFooter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports